import { createRoot, Suspense } from '@wordpress/element';
import { APIBlock } from './APIBlock';
import { Loading } from './Loading';

window.addEventListener( 'DOMContentLoaded', () => {
	const elements = document.querySelectorAll(
		'.wp-block-blocchi-api-bridge-connect-block'
	);

	if ( elements?.length ) {
		elements.forEach( ( element ) => {
			const root = createRoot( element );
			root.render(
				<Suspense fallback={ <Loading /> }>
					<APIBlock { ...element.dataset } />
				</Suspense>
			);
		} );
	}
} );